import React, { useState } from "react";
import { api } from "@/lib/api";
import { resolveMediaUrl } from "@/components/FileUpload";
import { Loader2, MessagesSquare, ChevronUp } from "lucide-react";

const fmt = (iso) => { try { return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

// Message signalé + les 5 messages avant / après (GET /admin/chat/message-context/{id}) pour juger avec le contexte.
export const ModerationMessageContext = ({ itemId, messageId }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  const toggle = async () => {
    if (open) { setOpen(false); return; }
    setOpen(true);
    if (rows) return;
    setLoading(true); setError(null);
    try {
      const { data } = await api.get(`/admin/chat/message-context/${messageId}`);
      setRows(data.messages || []);
    } catch (e) { setError(e?.response?.data?.detail || "Contexte indisponible"); }
    finally { setLoading(false); }
  };

  return (
    <div className="mt-1.5" data-testid={`mod-msg-context-${itemId}`}>
      <button onClick={toggle} className="text-[11px] font-medium inline-flex items-center gap-1" style={{ color: "var(--yalola-primary)" }} data-testid={`mod-msg-context-toggle-${itemId}`}>
        {open ? <ChevronUp size={12} /> : <MessagesSquare size={12} />} {open ? "Masquer le contexte" : "Voir le contexte (5 messages avant / après)"}
      </button>
      {open && (
        <div className="mt-1.5 rounded-xl border p-2 space-y-1 max-h-72 overflow-y-auto" style={{ borderColor: "var(--yalola-border)", background: "white" }} data-testid={`mod-msg-context-list-${itemId}`}>
          {loading && <div className="py-3 text-center"><Loader2 size={16} className="animate-spin mx-auto" /></div>}
          {error && <div className="text-xs text-red-600">{error}</div>}
          {rows && rows.length === 0 && <div className="text-xs" style={{ color: "var(--yalola-text-muted)" }}>Aucun message.</div>}
          {rows && rows.map((m) => (
            <div
              key={m.id}
              className="rounded-lg px-2 py-1.5 text-xs"
              style={m.is_target
                ? { background: "#FEF2F2", border: "1px solid #FCA5A5" }
                : { background: "var(--yalola-surface-alt)" }}
              data-testid={`mod-msg-context-row-${m.id}`}
              data-target={m.is_target ? "1" : undefined}
            >
              <div className="flex items-center justify-between gap-2">
                <span className="font-semibold truncate">{m.sender?.name || m.sender_id?.slice(0, 8) || "—"}{m.is_target && <span className="ml-1 text-[10px] font-bold uppercase text-red-600">· signalé</span>}</span>
                <span className="shrink-0" style={{ color: "var(--yalola-text-muted)" }}>{fmt(m.created_at)}</span>
              </div>
              <div className="mt-0.5 whitespace-pre-wrap break-words" style={{ color: m.is_deleted ? "var(--yalola-text-muted)" : "var(--yalola-text)" }}>
                {m.is_deleted ? <i>Message supprimé par l'expéditeur{m.content ? ` — original : « ${m.content} »` : ""}</i> : (m.original_content && m.original_content !== m.content ? `${m.content}  (original : « ${m.original_content} »)` : (m.content || (m.media_type ? `[${m.media_type}]` : "")))}
              </div>
              {m.media_url && !m.is_deleted && (m.media_type === "image" || m.media_type === "album") && (
                <img src={resolveMediaUrl(m.media_url)} alt="" className="mt-1 h-16 w-16 rounded object-cover blur-sm hover:blur-none transition-all" />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ModerationMessageContext;
